/**
 * Routes of the foundation. OWNED BY the foundation: tighten `validateSearch`, add loaders, swap `component`
 * for the real screen (keep the paths — boards.ts hrefs point at them). Generated by the foundation.
 */
import { createRoute } from "@tanstack/react-router";
import { boardsAt } from "@/boards/board-switch";
import { looseSearch, publicRoute } from "@/app/route-base";

/** Admin-Login */
export const connexionRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: "/connexion",
  validateSearch: looseSearch,
  component: boardsAt("/connexion"),
});

/** Admin-Login-Code */
export const connexionCodeRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: "/connexion/code",
  validateSearch: looseSearch,
  component: boardsAt("/connexion/code"),
});

/** Sign-in pages (no session): mounted under publicRoute. */
export const authPublicRoutes = [connexionRoute, connexionCodeRoute] as const;
